<template>
  <router-view name="emailList" :key="$route.path"></router-view>
</template>
<script>
export default {
  name: "EmailList",
};
</script>